import { render, staticRenderFns } from "./UserBookings.vue?vue&type=template&id=31f6ed2e&scoped=true"
import script from "./UserBookings.vue?vue&type=script&lang=js"
export * from "./UserBookings.vue?vue&type=script&lang=js"
import style0 from "./UserBookings.vue?vue&type=style&index=0&id=31f6ed2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f6ed2e",
  null
  
)

export default component.exports